import { BetCreateParams } from "src/store/api";

/**
 * Разбивает аргументы bet.create на отдельные запросы по balanceId.
 */
export const groupBetCreateByBalanceId = (
  args: BetCreateParams
): BetCreateParams[] => {
  const groups = new Map<
    number,
    { bets: BetCreateParams["bets"]; betParams: BetCreateParams["betParams"] }
  >();

  args.bets.forEach((bet, index) => {
    const entry = groups.get(bet.balanceId) ?? { bets: [], betParams: [] };
    entry.bets.push(bet);
    entry.betParams.push(args.betParams[index]);
    groups.set(bet.balanceId, entry);
  });

  return Array.from(groups.values()).map(({ bets, betParams }) => ({
    bets,
    betParams,
    contractor: args.contractor,
    gameId: args.gameId,
    token: args.token,
  }));
};
